(function () {
	function setDisabled(btn, disabled) {
		if (!btn) return;
		btn.disabled = disabled;
		btn.classList.toggle('is-disabled', disabled);
		btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
	}

	function applyPoster(inner) {
		var video = inner.querySelector('video.vdl__video');
		var url = inner.getAttribute('data-video-poster');
		if (video && url) {
			video.setAttribute('poster', url);
		}
	}

	function embedAutoplaySrc(baseSrc) {
		if (!baseSrc) return '';
		var join = baseSrc.indexOf('?') !== -1 ? '&' : '?';
		if (baseSrc.indexOf('youtube.com') !== -1 || baseSrc.indexOf('youtu.be') !== -1) {
			return baseSrc + join + 'autoplay=1';
		}
		if (baseSrc.indexOf('vimeo.com') !== -1) {
			return baseSrc + join + 'autoplay=1';
		}
		return baseSrc;
	}

	function setPanelEmbeds(panel, active, autoplay) {
		if (!panel) return;
		panel.querySelectorAll('iframe[data-vdl-iframe-src]').forEach(function (frame) {
			var baseSrc = frame.getAttribute('data-vdl-iframe-src');
			if (!baseSrc) return;
			if (active) {
				frame.setAttribute('src', autoplay ? embedAutoplaySrc(baseSrc) : baseSrc);
			} else {
				frame.removeAttribute('src');
			}
		});
	}

	function playPanelMedia(panel) {
		if (!panel) return;
		var video = panel.querySelector('video.vdl__video');
		if (video) {
			var playPromise = video.play();
			if (playPromise && typeof playPromise.catch === 'function') {
				playPromise.catch(function () {});
			}
			return;
		}
		var frame = panel.querySelector('iframe[data-vdl-iframe-src]');
		if (frame) {
			var baseSrc = frame.getAttribute('data-vdl-iframe-src');
			if (baseSrc) {
				frame.setAttribute('src', embedAutoplaySrc(baseSrc));
			}
		}
	}

	function init(root) {
		if (!root || root.dataset.vdlInit === '1') {
			return;
		}
		root.dataset.vdlInit = '1';

		var panels = root.querySelectorAll('[data-vdl-panel]');
		var items = root.querySelectorAll('[data-vdl-list-item]');
		var prev = root.querySelector('[data-vdl-prev]');
		var next = root.querySelector('[data-vdl-next]');
		var searchInput = root.querySelector('[data-vdl-search]');

		if (!panels.length) {
			return;
		}

		var index = 0;

		function normalizeIndex(i) {
			return Math.max(0, Math.min(i, panels.length - 1));
		}

		function show(i, options) {
			options = options || {};
			var shouldPlay = options.play === true;
			var nextIdx = normalizeIndex(i);
			index = nextIdx;

			panels.forEach(function (panel, pi) {
				var active = pi === index;
				panel.classList.toggle('is-active', active);
				panel.setAttribute('aria-hidden', active ? 'false' : 'true');
				setPanelEmbeds(panel, active, active && shouldPlay);
				if (active) {
					panel.removeAttribute('inert');
					if (shouldPlay) {
						playPanelMedia(panel);
					}
				} else {
					panel.setAttribute('inert', '');
					panel.querySelectorAll('video').forEach(function (v) {
						try {
							v.pause();
						} catch (e) {}
					});
				}
			});

			items.forEach(function (btn, bi) {
				var active = bi === index;
				btn.classList.toggle('is-active', active);
				if (active) {
					btn.setAttribute('aria-current', 'true');
				} else {
					btn.removeAttribute('aria-current');
				}
			});

			setDisabled(prev, index === 0);
			setDisabled(next, index === panels.length - 1);
		}

		panels.forEach(function (panel) {
			var inner = panel.querySelector('.vdl__theater-inner');
			if (inner) {
				applyPoster(inner);
			}
		});

		show(0);

		items.forEach(function (btn) {
			btn.addEventListener('click', function () {
				var wrap = btn.closest('.vdl__list-item-wrap');
				if (wrap && wrap.classList.contains('is-hidden')) {
					return;
				}
				var i = parseInt(btn.getAttribute('data-vdl-list-item'), 10);
				if (Number.isNaN(i)) {
					return;
				}
				if (i === index) {
					playPanelMedia(panels[index]);
				} else {
					show(i, { play: true });
				}
			});
		});

		if (prev) {
			prev.addEventListener('click', function () {
				show(index - 1);
			});
		}
		if (next) {
			next.addEventListener('click', function () {
				show(index + 1);
			});
		}

		function runSearch() {
			var q =
				searchInput && searchInput.value ? searchInput.value.trim().toLowerCase() : '';
			root.querySelectorAll('.vdl__list-item-wrap').forEach(function (wrap) {
				var hay = (wrap.getAttribute('data-vdl-search') || '').toLowerCase(); 
				var match = !q || hay.indexOf(q) !== -1;
				wrap.classList.toggle('is-hidden', !match);
			});

			var activeBtn = root.querySelector('[data-vdl-list-item].is-active');
			if (activeBtn) {
				var activeWrap = activeBtn.closest('.vdl__list-item-wrap');
				if (activeWrap && activeWrap.classList.contains('is-hidden')) {
					for (var j = 0; j < items.length; j++) {
						var w = items[j].closest('.vdl__list-item-wrap');
						if (w && !w.classList.contains('is-hidden')) {
							var ni = parseInt(items[j].getAttribute('data-vdl-list-item'), 10);
							if (!Number.isNaN(ni)) {
								show(ni);
							}
							break;
						}
					}
				}
			}
		}

		if (searchInput) {
			searchInput.addEventListener('input', runSearch);
			searchInput.addEventListener('search', runSearch);
		}
	}

	function scan(container) {
		var root = container || document;
		if (root.matches && root.matches('[data-vdl-root]')) {
			init(root);
		}
		root.querySelectorAll('[data-vdl-root]').forEach(init);
	}

	document.addEventListener('DOMContentLoaded', function () {
		scan(document);
	});

	document.addEventListener('shopify:section:load', function (ev) {
		if (!ev.target) {
			return;
		}
		scan(ev.target);
	});
})();
